export default __webpack_public_path__ + "static/media/baner-top_kolowrotek_2027.5eae3baf.jpg";